import * as React from 'react';

function SvgPalette2(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M0 .5A.5.5 0 01.5 0h5a.5.5 0 01.5.5v5.277l4.147-4.131a.5.5 0 01.707 0l3.535 3.536a.5.5 0 010 .708L10.261 10H15.5a.5.5 0 01.5.5v5a.5.5 0 01-.5.5H3a2.99 2.99 0 01-2.121-.879A2.99 2.99 0 010 13.044m6-.21l7.328-7.3-2.829-2.828L6 7.188v5.647zM4.5 13a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM15 15v-4H9.258l-4.015 4H15zM0 .5v12.495V.5z' />
			<path d='M0 12.995V13a3.07 3.07 0 000-.005z' />
		</svg>
	);
}

export default SvgPalette2;
